
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'

import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import Vuetify from 'vuetify'
import Cookie from 'vue-cookie'

import Main from '@/assets/javascript/main'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/css/main.css'

import i18n from '@/plugins/i18n'

import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import VueQuagga from 'vue-quaggajs'

import Prefs from '@/assets/javascript/prefs'

Vue.use(Cookie)
Vue.use(Vuetify)
Vue.use(wysiwyg, {})
Vue.use(VueQuagga)

Vue.$prefs = new Prefs()

const vuetifyOpts = {
  theme: {
    themes: {
      light: {
        primary: '#4b526d',
        secondary: '#6b739d',
        accent: '#393e53',
        error: '#B71C1C'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  vuetify: new Vuetify(vuetifyOpts),
  i18n
})

let main = new Main(store, router)
main.enforceAuthentication()
main.startSessionChecker()



// WEBPACK FOOTER //
// ./src/main.js